module.exports = __webpack_public_path__ + "media/images/icons/icon-skirt-66ed3e3187b6b9714be8b5f8a4783cb1.svg";